import React from "react";

export const Services = ({ data }) => {
  const projects = data || [];
  const projectCount = Math.min(projects.length || 1, 4);

  return (
    <section id="projects" className="section projects-section">
      <div className="section-heading">
        <p className="eyebrow">Projects and semi-jokes</p>
        <h2>Experiments that accidentally became products.</h2>
        <p>
          A mix of client-useful systems, internal experiments, and tiny acts of
          product mischief. The thread running through them is simple: design it
          properly, engineer it cleanly, and let it have a pulse.
        </p>
      </div>

      <div className={`project-grid project-count-${projectCount}`}>
        {projects.map((project) => (
          <article className="project-card" key={project.name}>
            <div className="project-card-top">
              <i className={project.icon} aria-hidden="true"></i>
              <span>{project.status}</span>
            </div>
            <h3>{project.name}</h3>
            <p>{project.text}</p>
            <div className="tag-list">
              {project.tags.map((tag) => (
                <span key={tag}>{tag}</span>
              ))}
            </div>
            <a href={project.href} className="project-link">
              Open project
            </a>
          </article>
        ))}
      </div>
    </section>
  );
};
